import React from "react";
import AppBar from "../../Components/header";
import AppProvider from "../../Components/bootstrap";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Button, Paper, Grid, Typography, makeStyles } from "@material-ui/core";
import { Loading } from "react-admin";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Parse from "parse";
import { useEffect } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useAuthenticated } from "react-admin";
import { useHistory, Route } from "react-router-dom";
import { createMuiTheme } from "@material-ui/core/styles";
import AddMyOffer from "./AddOfferDialog";
const useStyles = makeStyles((theme) => ({
  main: {
    marginTop: "8%",
    background: "transparent",
  },
  mainSm: {
    marginTop: "15%",
    background: "transparent",
  },
  buttons: {
    margin: "10% 0",
  },
  list: {
    margin: "1%",
  },
  listHeader: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "73.33%",
    flexShrink: 0,
  },
  listHeaderSm: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  dateTimeDetails: {
    flexBasis: "10.33%",
    fontSize: theme.typography.pxToRem(15),
    fontWeight: "400",
    marginLeft: ".3rem",
  },
  dateTimeDetailsSm: {
    flexBasis: "30.33%",
    fontSize: theme.typography.pxToRem(15),
    fontWeight: "400",
    marginLeft: ".3rem",
  },
  icons: {
    marginTop: ".1rem",
    fontSize: "1.4rem",
    color: "rgb(167, 91, 58)",
  },
  chips: {
    color: "#fff",
    margin: ".2rem",
  },
  paper: {
    marginLeft: "-.2rem",
  },
  panel: {
    minWidth: "70vw",
    margin: "auto",
  },
}));

const mentorTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#EF8354",
    },
  },
});

const MyOffers = (props) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));
  const user = Parse.User.current();
  const History = useHistory();
  console.log("props", props);
  console.log("isDesktop", isDesktop);

  useAuthenticated();
  return (
    <AppProvider>
      <Route path="/myoffers/add" component={AddMyOffer} noLayout />,
      <AppBar />
      <Paper
        elevation={0}
        className={isDesktop ? classes.main : classes.mainSm}
      >
        <Grid container direction="column" alignItems="center">
          <Grid item xs={12}>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                History.push({
                  pathname: "/myoffers/add",
                });
              }}
              style={{
                alignContent: "right",
                borderRadius: "10vh",
                marginTop: "2vh",
              }}
            >
              Add Your Offer
            </Button>
          </Grid>
          <Grid item xs={12}>
            <MyOffersList
              className={classes.list}
              currentUser={user}
              {...props}
            />
          </Grid>
        </Grid>
      </Paper>
    </AppProvider>
  );
};
const MyOffersList = (props) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));
  const currentUser = Parse.User.current();
  const [offerList, setOfferList] = React.useState();
  const [loading, setLoading] = React.useState(true);
  console.log("props", props);
  useAuthenticated();
  useEffect(() => {
    setLoading(true);
    setOfferList(null);
    const Offer = Parse.Object.extend("Offer");
    const query = new Parse.Query(Offer);
    query.equalTo("user", currentUser);
    // query.equalTo("isApproved", true);
    const result = query.find();
    result.then(
      (resp) => {
        setOfferList(
          resp.map((value) => ({
            id: value.id,
            ...value.attributes,
          }))
        );
        setLoading(false);
      },
      (err) => {
        console.log("Error", err);
        setOfferList(err);
        setLoading(false);
      }
    );
  }, [currentUser, props.location]);

  console.log("offerList", offerList);
  return (
    <AppProvider>
      <AppBar />
      <div
        style={{
          marginTop: "10vh",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          offerList.map((a) => {
            return (
              <Paper
                elevation={0}
                className={isDesktop ? classes.paper : classes.mainSm}
              >
                <ExpansionPanel className={classes.panel}>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    // aria-controls={`${
                    //   ZoomMeeting.hasOwnProperty("uuid") ? ZoomMeeting.uuid : ""
                    // }-content`}
                    // id={`${
                    //   ZoomMeeting.hasOwnProperty("uuid") ? ZoomMeeting.uuid : ""
                    // }-header`}
                  >
                    <Typography
                      className={
                        isDesktop ? classes.listHeader : classes.listHeaderSm
                      }
                    >{`Offer : ${a.offerTitle}`}</Typography>
                    <Typography
                      className={
                        isDesktop ? classes.listHeader : classes.listHeaderSm
                      }
                    >{`Status : ${a.status}`}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid container direction="row" spacing={4}>
                      <Grid item xs={12} md={6}>
                        <Grid container spacing={2} direction="column">
                          <Grid item>
                            <Typography variant="h6">Offer Details</Typography>
                          </Grid>
                          <Grid item>
                            <Grid container direction="column" spacing={2}>
                              <Grid item>
                                <Grid container direction="row">
                                  <Grid item md={4} sm={6}></Grid>
                                  <Grid item>
                                    <Typography variant="body2">
                                      <img
                                        style={{
                                          width: "40%",
                                          height: "30%",
                                        }}
                                        src={
                                          a.offerImage ? a.offerImage._url : ""
                                        }
                                        alt=""
                                      />
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <Grid container direction="row">
                                  <Grid item md={4} sm={6}>
                                    <Typography variant="body2">
                                      {"Description"}
                                    </Typography>
                                  </Grid>
                                  <Grid item md={4} sm={6}>
                                    <Typography variant="body2">
                                      {a.offerDescription}
                                    </Typography>
                                  </Grid>
                                </Grid>

                                <Grid container direction="row">
                                  <Grid item md={4} sm={6}>
                                    <Typography variant="body2">
                                      Approved
                                    </Typography>
                                  </Grid>
                                  <Grid item md={4} sm={6}>
                                    <Typography variant="body2">
                                      {a.isApproved ? "TRUE" : "FALSE"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item></Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Paper>
              // <div>Comming Soon...</div>
            );
          })
        )}
      </div>
    </AppProvider>
  );
};

export default MyOffers;
